module.exports = __webpack_public_path__ + "media/laws-bg2@2x.d918e157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2@2x.jpg
// module id = 1348
// module chunks = 57